import { create } from 'zustand';
import { formBuilderEntrySlice } from './formBuilderEntrySlice.slice';
import { formBuilderTemplatesSlice } from './formBuilderTemplates.slice';
import { documentManagementPacketsSlice } from './formPackets.slice';
import { TDocumentManagementStore } from './types';

export const useDocumentManagementStore = create<TDocumentManagementStore>(
  (...arg) => ({
    ...formBuilderTemplatesSlice(...arg),
    ...documentManagementPacketsSlice(...arg),
    ...formBuilderEntrySlice(...arg),
  }),
);
